import BaseModelAPI from '../BaseModelAPI';

export default class SuratJalanSupplyForSubcontract extends BaseModelAPI {
    static entity = '';
    static entityName = 'suratjalansupplyforsubcontract';

    constructor() {
        super();

        /*APP_MODEL_DEFINITION*/
        this.id = '';
        this.suratJalanNo = '';
        this.workOrderSupplySubcontractId = '';
        this.workOrderSupplySubcontract = {};
        this.deliveryDate = '';
        this.isAlreadyDelivered = false;
        this.purchaseOrderId = '';
        this.purchaseOrder = {};
        this.vendorId = '';
        this.vendor = {};
        this.driverName = '';
        this.vehicleNumber = '';
        this.picSuratJalan = '';
        this.adminSuratJalan = '';
        this.suratJalanSupplyForSubcontractDetail = []
        this.isFromUpload = false;
        this.isSavedToBackend = true;
        this.uploadValidationMessage = '';
        this.uploadValidationStatus = '';
        /*END_APP_MODEL_DEFINITION*/
    }

	static generateSJSupplyForSubContract(this_, id) {
		return this_.$http.get(`${this.entityName}/generatesjsupplyforsubcont/${id}`, null)
			.then(response => {
				return response.data;
			})
			.catch(function(error){
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}
}